module.exports = "<div class=\"alert alert-danger\"> <p>Page that you're looking for is not available</p> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/NotFound.vue
 ** module id = 54
 ** module chunks = 0
 **/